/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import CompanyVerification from '../CompanyVerification'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { ServerError, useMutation } from '@apollo/client'
import mutations from '../../../../setup/graphql/mutations'
import Alert from '../../../../_metronic/partials/alert'
import { fetchStart, fetchStop } from '../../../../redux/actions/common'
import { setLoanApplication, setLoanSubStep } from '../redux/actions'
import BankStatementValidator from '../../../../components/BankStatementValidator/BankStatementValidator'
import { generatePerfiosReport} from '../../../../components/BankStatementValidator/utils/perfiosTransaction'
import { areAllFsYearsComplete } from '../../loanApplication/utils/fsValidation'
import { CustomLoaderModal } from '../../../../_metronic/helpers/components/CustomLoaderModal'

import { Modal } from 'react-bootstrap-v5'
import { AlexiApplicationTypes } from '../../../../utils/constants/AlexiApplicationType.enum'
import { Stack } from 'react-bootstrap'
import { UploadIcon } from '../../../../svg/UploadIcon'
import { Xicon } from '../../../../svg/Xicon'
import { LeftArowIcon } from '../../../../svg/LeftArowIcon'
import { useHistory } from 'react-router-dom'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { CheckCircleIcon } from '../../../../svg/CheckCircleIcon'
import FileUploadInfo from '../../../../components/BankStatementValidator/FileUploadInfo/FileUploadInfo'
import FinancialStatementsUpload from '../../loanApplication/components/FinancialStatementsUpload'
import { cleanFileNameDynamic } from '../../../constants/commonFunctions'
import {
  addFinancialYear,
  uploadFinancialStatements,
} from '../../../../components/BankStatementValidator/utils/fsTransaction'
import { Box } from '@mui/material'
import FinancialSidebar from './FinancialSidebar'
import {
  DocumentConfig,
  DocumentLabel,
  DocumentLabels,
  DOCUMENTS,
  DocumentType
} from '../utils/constants'
import FinancialStatementsUploadForAgentClientOnboarding from '../../loanApplication/components/FinancialStatementUploadForAgentClientOnboarding'
import {DocumentSubmittedScreen} from './DocumentSubmittedScreen'
import { useTruncatedFilename } from '../utils/useTruncatedFilename'
import DocumentUploadSection from './DocumentUploadSection'
import { RootState } from '../../../../setup'

const Step2: FC = ({
  // prevStep,
  // goToStep,
  getApplication,
  updateApplication,
}: any) => {
  const dispatch = useDispatch()
  const xlsxRef: any = useRef()
  const history: any = useHistory()
  const [openCustomLoaderModal, setOpenCustomLoaderModal] = useState<boolean>(false)
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  const [openVerification, setOpenVerification] = useState(false)
  const [fileGroup, setFileGroup] = useState<any>([])
  const [validateStmtsNow, setValidateStmtsNow] = useState<boolean>(true)
  const [reuploadWarningModal, setReuploadWarningModal] = useState<boolean>(false)
  const [removeAllUploadedStatements, setRemoveAllUploadedStatements] = useState<boolean>(false)
  const [isBankReportGenerated, setIsBankReportGenerated] = useState<boolean>(false)
  const [uploadedFiles, setUploadedFiles] = useState<any>([])
  const [uploadedCorrectStatements, setUploadedCorrectStatements] = useState(false)
  const [pendingFs, setPendingFs] = useState<
    Array<{ id: string; year: number; file: File; filename: string }>
  >([])
  const [documents, setDocuments] = useState<Record<string, any>>(DOCUMENTS)
  const [render, setRender] = useState<DocumentLabel>(DocumentLabels.BANK_STATEMENTS)
  const [allDocumentSubmitted, setAllDocumentSubmitted] = useState<boolean>(false)
  const [uploadingType, setUploadingType] = useState<string | null>(null)
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [uploadingFinancialStatements, setUploadingFinancialStatements] = useState<{type: string, isLoading: boolean}[]>([])
  const [createIncomeDocument, onSuccessCreateIncomeDocument] = useMutation(
    mutations.CREATE_INCOME_DOCUMENTS,
    {
      onCompleted: () => {
        setUploadingType(null)
        setUploadingFinancialStatements([])
      },
      onError: () => {
        setUploadingType(null)
      },
      
    }
  )
  const [deleteIncomeDocument] = useMutation(mutations.DELETE_INCOME_DOCUMENT)

  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const responseUser: any = useSelector((state: RootState) => state.authUser.authUser)

  let fullNameOfAgent: string;
  if (responseUser) {
    fullNameOfAgent = responseUser.firstName + ' ' + responseUser.lastName
  } else {
    fullNameOfAgent =
      JSON.parse(localStorage.getItem('userDetails') || '')?.firstName +
      ' ' +
      JSON.parse(localStorage.getItem('userDetails') || '')?.lastName
  }

  const loanType = localStorage.getItem('loanType');



  const queueFsFile = (year: number, file: File, prefixedName: string) => {
    const currentYear = new Date().getFullYear()
    const yearKey = year === currentYear - 3 ? 'y1' : year === currentYear - 2 ? 'y2' : 'y3'
    const tempId = `temp-fs-${yearKey}`

    // Only remember for addFinancialYear later; do NOT push any temp into fileGroup
    setPendingFs((prev) => {
      const filtered = prev.filter((p) => p.id !== tempId)
      return [...filtered, { id: tempId, year, file, filename: prefixedName }]
    })
  }

  useEffect(() => {
    if (loanApplication?.incomeDocuments) {
      const { incomeDocuments } = loanApplication
      let file = []
      for (const document of incomeDocuments) {
        const _file = {
          id: document.id,
          type: document.type,
          file: document.documentFile,
        }
        file.push(_file)
      }

      const bankStatements = file.filter(({ type }: any) => type === 'bank-statement')
      if (
        bankStatements &&
        bankStatements.length &&
        loanApplication?.bankStatementsReportFileName &&
        loanApplication?.bankStatementsReportFilePath
      ) {
        setIsBankReportGenerated(true)
      }

      setValidateStmtsNow(loanApplication?.perfiosIntegration)
      setFileGroup(file)
    }
  }, [loanApplication, loanApplication?.incomeDocuments])

  useEffect(() => {
    if (removeAllUploadedStatements) {
      handleRemoveAllIncomeDocuments()
    }
  }, [removeAllUploadedStatements])

  useEffect(() => {
    if (onSuccessCreateIncomeDocument.called && !onSuccessCreateIncomeDocument.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateIncomeDocument.data) {
        if (onSuccessCreateIncomeDocument.data) {
          const { createIncomeDocuments } = onSuccessCreateIncomeDocument.data
          let file = [...fileGroup]
          for (const document of createIncomeDocuments) {
            const _file = {
              id: document.id,
              type: document.type,
              file: document.documentFile,
            }
            file.push(_file)
          }

          setFileGroup(file)

          if (loanApplication.applicationCompleteStep < 2) {
            updateApplication({
              variables: {
                data: { applicationCompleteStep: 2 },
                where: { id: loanApplication.id },
              },
            })
          }

          onSuccessCreateIncomeDocument.reset()
        }
      } else {
      }

      if (onSuccessCreateIncomeDocument.error) {
        const { networkError } = onSuccessCreateIncomeDocument.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
      }
    }
  }, [
    onSuccessCreateIncomeDocument.loading,
    onSuccessCreateIncomeDocument.data,
    onSuccessCreateIncomeDocument.error,
    onSuccessCreateIncomeDocument.called,
  ])

  const updateDocumentStatuses = (fileGroup: any[], uploadedCorrectStatements?: boolean) => {
    setDocuments((prev) => {
      const updatedDocs = { ...prev }

      // Update bank statements based on validation
      if (validateStmtsNow && (uploadedCorrectStatements || isBankReportGenerated)) {
        updatedDocs.BANK_STATEMENTS = { ...prev.BANK_STATEMENTS, uploaded: true }
      } else if(validateStmtsNow && (!uploadedCorrectStatements || isBankReportGenerated)) {
        updatedDocs.BANK_STATEMENTS = { ...prev.BANK_STATEMENTS, uploaded: false }
      }

      

      // Define file type to document key mappings
      const fileTypeToDocKey: Record<string, keyof typeof DocumentLabels> = {
        'financial-statement': 'FINANCIAL_STATEMENTS',
        'company-loan-declaration': 'COMPANY_LOAN_DECLARATION',
        'cs-iras-form': 'FORM_C_S',
        'gst-statement': 'LATEST_4_QUARTERS_GST_RETURNS',
        'acra-details': 'LATEST_MONTHS_ACRA',
        'ar-ap-ageing': 'LATEST_AR_AP_AGEING',
        'nric-document': 'NRIC_OF_GUARANTORS',
        'cbs-report': 'LATEST_MONTHS_CBS_REPORT',
        'mlcb-report': 'LATEST_MONTHS_MLCB_REPORT',
        'basic-individual-search': 'LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH',
        'noa-document': 'LATEST_2_YEARS_NOA',
        'cpf-statement': 'LATEST_YEARS_CPF_STATEMENTS',
      }

      // Update each document type based on file presence and conditions
      Object.entries(fileTypeToDocKey).forEach(([fileType, docKey]) => {
        const isPresent = fileGroup.some(({ type: fileTypeInGroup }: any) => fileTypeInGroup === fileType)

        let shouldUpload = isPresent

        // Special condition for financial statements
        if (fileType === 'financial-statement' && isPresent) {
          shouldUpload = areAllFsYearsComplete(fileGroup)
        }

        if (shouldUpload) {
          updatedDocs[docKey] = { ...prev[docKey], uploaded: true }
        } else {
          updatedDocs[docKey] = { ...prev[docKey], uploaded: false }
        }
      })

      return updatedDocs
    })
  }

  useEffect(() => {
   
    updateDocumentStatuses(fileGroup, uploadedCorrectStatements)
  }, [fileGroup, uploadedCorrectStatements, isBankReportGenerated])

  const isValidFile = (event: any, fileTypes: string[], docType: string = '') => {
    const excelTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
      'application/octet-stream', // Some Excel files might have this type
      'application/zip', // .xlsx is actually a zip file
    ]

    const isExcelFile = (file: File) => {
      const fileName = file.name.toLowerCase()
      return (
        excelTypes.includes(file.type) ||
        fileName.endsWith('.xlsx') ||
        fileName.endsWith('.xls') ||
        file.type === ''
      ) // Sometimes Excel files might not have a type
    }

    const isPdfFile = (file: File) => {
      return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
    }

    const isValidType = (file: File) => {
      if (fileTypes.includes('application/pdf') && isPdfFile(file)) return true
      if (
        (fileTypes.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          fileTypes.includes('application/vnd.ms-excel')) &&
        isExcelFile(file)
      )
        return true
      return fileTypes.includes(file.type)
    }

    const checkType = [...event.target.files].some((file: File) => !isValidType(file))
    if (checkType) {
      const docTypeDisplay = getDocTypeDisplay(docType)

      setShowAlert(true)
      setAlertMsg(`Please upload a valid ${docTypeDisplay}`)
      setAlertType('primary')

      // Clear the file input
      event.target.value = ''
      event.target.files = null
      return false
    }
    return true
  }

  const getDocTypeDisplay = (docType: string): string => {
    switch (docType) {
      case 'bank-statement':
        return 'Bank Statement'
      case 'revenue-financing-statement':
        return 'Revenue Financing Statement'
      case 'financial-statement':
        return 'Financial Statement'
      case 'company-loan-declaration':
        return 'Company Loan Declaration'
      case 'cs-iras-form':
        return 'C/C-S form'
      case DocumentType.LATEST_MONTHS_ACRA:
        return 'ACRA of the Company'
      case DocumentType.LATEST_4_QUARTERS_GST_RETURNS:
        return 'GST Returns'
      case DocumentType.LATEST_AR_AP_AGEING:
        return 'AR & AP Ageing'
      case DocumentType.NRIC_OF_GUARANTORS:
        return 'NRIC of Guarantors'
      case DocumentType.LATEST_MONTHS_CBS_REPORT:
        return 'CBS Report of Guarantors'
      case DocumentType.LATEST_MONTHS_MLCB_REPORT:
        return 'MLCB Report of Guarantors'
      case DocumentType.LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH:
        return 'Basic Individual Search of Key Guarantors'
      case DocumentType.LATEST_YEARS_CPF_STATEMENTS:
        return 'CPF Statements of Guarantors'
      case DocumentType.LATEST_2_YEARS_NOA:
        return 'NOA of Guarantors'
      default:
        return 'File'
    }
  }

  const handleFileUpload = (
    event: any,
    type: string,
    fileType: string[] = ['application/pdf'],
    year?: number
  ) => {

    if (type !== DocumentType.FINANCIAL_STATEMENT) {
      setUploadingType(type)
    } else {
      setUploadingFinancialStatements((prev: any) => {
        const existingItem = prev.find((item: any) => item.type === `upload-file-${year}`)

        if (existingItem) {
          // Update existing item's isLoading to true
          return prev.map((item: any) =>
            item.type === `upload-file-${year}`
              ? { ...item, isLoading: true }
              : item
          )
        } else {
          // Add new item
          return [...prev, { type: `upload-file-${year}`, isLoading: true }]
        }
      })
    }

    if (event.target.validity.valid) {
      let files = []
      let uploadDocs = []

      const isValid = isValidFile(event, fileType, type)

      if (isValid) {
        for (let file of event.target.files) {
          const isExists = fileGroup.some((f: any) => {
            return (
              cleanFileNameDynamic(f.file.filename) === cleanFileNameDynamic(file.name) &&
              f.type === type
            )
          })

          if (!isExists) {
            /**
             * FINANCIAL STATEMENT YEAR PREFIXING LOGIC
             *
             * For financial statements, we prepend a year-specific prefix to filenames
             * to organize files by year boxes. This ensures files uploaded to specific
             * year boxes remain in those boxes permanently.
             *
             * Year Key Mapping (HARDCODED for data consistency):
             * - y1- prefix = 2022 files (Past year 1)
             * - y2- prefix = 2023 files (Past year 2)
             * - y3- prefix = 2024/25 files (Current management year)
             *
             * Example: "statement.pdf" uploaded to 2023 box becomes "y1-statement.pdf"
             */
            if (type === 'financial-statement' && year) {
              // Determine year key based on financial year mapping
              // If current year is 2025: y1=2022, y2=2023, y3=2024 (for FY 2024-25)
              const currentYear = new Date().getFullYear()
              const yearKey =
                year === currentYear - 3 ? 'y1' : year === currentYear - 2 ? 'y2' : 'y3'

              // Create a new File object with the prefixed filename
              // This ensures the actual uploaded file has the correct name
              const newFile = new File([file], `${yearKey}-${file.name}`, { type: file.type })

              // Add custom filename property for internal tracking and display
              Object.defineProperty(newFile, 'filename', {
                value: `${yearKey}-${file.name}`,
                writable: true,
              })

              files.push({ type: type, file: newFile })
            } else {
              // For non-financial statement files, use original filename
              Object.defineProperty(file, 'filename', {
                value: file.name,
                writable: true,
              })
              files.push({ type: type, file })
            }

            uploadDocs.push({
              application: {
                connect: {
                  id: loanApplication.id,
                },
              },
              type: type,
              documentFile: {
                upload: files[files.length - 1]?.file || file,
              },
              uploadedBy: fullNameOfAgent,
            })

            if (
              loanType &&
              loanType.toLowerCase() === AlexiApplicationTypes.RECURRING_APPLICATION
            ) {
              event.target.value = ''
              if (xlsxRef?.current?.value) {
                xlsxRef.current.value = null
              }
            }
          } else {
            event.target.value = ''
            setShowAlert(true)
            setAlertMsg('File already exists')
            setUploadingFinancialStatements([])
            setAlertType('primary')
            return
          }
        }

        if (files.length) {
          event.target.value = ''
          createIncomeDocument({
            variables: {
              data: uploadDocs,
            },
          })

          // dispatch(fetchStart())
        }
        event.target.value = ''
      }
    }
  }

  const handleRemoveAllIncomeDocuments = () => {
    try {
      if (fileGroup && fileGroup?.length) {
        const allIncomeDocs = fileGroup.filter(({ type }: any) => type === 'bank-statement')
        const otherDocs = fileGroup.filter(({ type }: any) => type !== 'bank-statement')
        for (const file of allIncomeDocs) {
          deleteIncomeDocument({
            variables: {
              where: { id: file.id },
            },
          })
        }
        updateApplication({
          variables: {
            data: {
              applicationCompleteStep: 2,
              bankStatementsReportFileName: '',
              bankStatementsReportFilePath: '',
              bankStatementsXlsxReportFileName: '',
              bankStatementsXlsxReportFilePath: '',
            },
            where: { id: loanApplication.id },
          },
        })
        setIsBankReportGenerated(false)
        setFileGroup(otherDocs)
      }
    } catch (error) {
      throw error
    }
  }

  const handleStatementUpload = async (type: string = '') => {
    try {
      let files = []
      let uploadDocs = []

      for (let file of uploadedFiles) {
        const { response, ...restFileData } = file
        file.filename = file.name
        files.push({ type: type, restFileData })
        uploadDocs.push({
          application: {
            connect: {
              id: loanApplication.id,
            },
          },
          type: type,
          documentFile: {
            upload: file,
          },
          uploadedBy: fullNameOfAgent,
        })
      }

      // _fileGroup = _fileGroup.concat(files);
      // setFileGroup(_fileGroup);

      return createIncomeDocument({
        variables: {
          data: uploadDocs,
        },
      }).then((response: any) => {
        const { createIncomeDocuments } = response?.data

        return createIncomeDocuments
      })
    } catch (error) {
      throw error
    }
  }

  const submitAll = async () => {
    try {
      setOpenCustomLoaderModal(true)

      // 1) Handle pending financial statements first (like loan application)
      if (pendingFs.length) {
        for (const p of pendingFs) {
          try {
            await addFinancialYear(p.file, p.year.toString(), loanApplication.id, true)
          } catch (e) {
            console.error('addFinancialYear (current FY) failed on submit:', e)
            // continue; we proceed with the rest
          }
        }
        setPendingFs([])
      }

      // 2) Trigger final FS consolidation/upload job
      try {
        await uploadFinancialStatements()
      } catch (fsError) {
        setOpenCustomLoaderModal(false)
        setShowAlert(true)
        setAlertMsg('Failed to upload financial statements')
        setAlertType('primary')
        return
      }

      // 3) Handle bank statements (with agent-specific conditions)
      if (
        validateStmtsNow &&
        loanApplication.applicationCompleteStep < 3 &&
        (!loanApplication.bankStatementsReportFilePath || removeAllUploadedStatements)
      ) {
        const report = await retrieveBankReport()
        const incomeDocs: any = await handleStatementUpload('bank-statement')
        updateApplication({
          variables: {
            data: {
              applicationStatus: 'documents-uploaded',
              applicationCompleteStep: 2,
              bankStatementsReportFileName: report?.reportFileName,
              bankStatementsReportFilePath: report?.reportFilePath,
              bankStatementsXlsxReportFileName: report?.reportXlsxFileName,
              bankStatementsXlsxReportFilePath: report?.reportXlsxFilePath,
            },
            where: { id: loanApplication.id },
          },
        })
       
        const applications = {
          ...loanApplication,
          applicationStatus: "documents-uploaded",
          incomeDocuments: [...loanApplication.incomeDocuments, ...incomeDocs],
          applicationCompleteStep: 2,
          bankStatementsReportFileName: report?.reportFileName,
          bankStatementsReportFilePath: report?.reportFilePath,
          bankStatementsXlsxReportFileName: report?.reportXlsxFileName,
          bankStatementsXlsxReportFilePath: report?.reportXlsxFilePath,
        }
        dispatch(setLoanApplication(applications))
        setUploadedFiles([])
        setIsBankReportGenerated(true)
      }

      setOpenCustomLoaderModal(false)

      // 4) Agent-specific navigation logic
      if (loanApplication.applicationCompleteStep >= 3) {
        history.push(`/agent-application/${loanApplication.id}?step=3`)
        return
      }

      // 5) Open verification modal after all processing is complete
      // setOpenVerification(true)
      setAllDocumentSubmitted(true)

    } catch (error: any) {
      setOpenCustomLoaderModal(false)
      setShowAlert(true)
      setAlertMsg(error?.response?.data?.message || error?.response?.data || error?.message)
      setAlertType('primary')
    }
  }

  /**
   * Calls generate report api
   * @returns report details uploaded on azure
   */
  const retrieveBankReport = async () => {
    try {
      const report = await generatePerfiosReport(
        loanApplication?.id,
        `${loanApplication?.id}_report`,
        loanApplication?.applicationType
      )
      return report
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  const removeSingleFile = async (id: string) => {
    if (id.startsWith('temp-fs-')) {
      setPendingFs((prev) => prev.filter((p) => p.id !== id))
      setFileGroup((prev: any[]) => prev.filter((o: any) => o.id !== id))
      return
    }
    const _fileGroup = fileGroup.filter((o: any) => o.id !== id)
    setFileGroup(_fileGroup)
    await deleteIncomeDocument({ variables: { where: { id } } })
  }

  const removeAllFiles = async (type: string) => {

    const _fileGroup = fileGroup.filter((o: any) => o.type !== type)
    const _tobeDeletedFiles = fileGroup.filter((o: any) => o.type === type)
    setFileGroup(_fileGroup)

    await Promise.all(_tobeDeletedFiles.map(async (file: any) => {
      await deleteIncomeDocument({ variables: { where: { id: file.id } } })
    }))
  }

  const reuploadAccepted = () => {
    setValidateStmtsNow(!validateStmtsNow)
    setReuploadWarningModal(false)
    handleRemoveAllIncomeDocuments()
    setUploadedFiles([])
  }

  function backLink() {
    dispatch(setLoanSubStep(1))
    history.replace(`/agent-application/${loanApplication.id}?step=1.1`)
  }

const FileItem = React.memo(({ file, id, removeSingleFile }: any) => {
  // The hook tracks the width of the text area specifically
  const { containerRef, displayName } = useTruncatedFilename(file.filename);

  return (
    <div
      style={{
        fontSize: 14,
        color: "#616B75",
        border: "1px solid #E0E0E0",
        borderRadius: "20px",
        padding: "8px 16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        gap: "8px", 
      }}
    >
      <div 
        ref={containerRef} 
        style={{ flex: 1, minWidth: 0, overflow: "hidden" }}
      >
        <span title={file.filename}>
          {displayName}
        </span>
      </div>

      <Xicon
        onClick={() => removeSingleFile(id)}
        className="cursor-pointer"
        style={{ flexShrink: 0, cursor: 'pointer' }} 
      />
    </div>
  );
});

  return (
    <Box >
      {!allDocumentSubmitted && 
        <>
          <Box display='flex' gap={2} >
            <Box sx={{ width: '36%' }}>
              <FinancialSidebar  uploadedCorrectBankStatements={uploadedCorrectStatements} loading={onSuccessCreateIncomeDocument.loading || isUploading} documents={documents} onSelect={(key: DocumentConfig)=> {
                setRender(key.label)
                
              }} />
            </Box>
            <Box sx={{ height: 'calc(100vh - 310px)', overflow: 'auto', border: '1px solid #E0E0E0', borderRadius: '8px', width: '64%' }}>
              <div className='d-flex flex-column flex-column-fluid' style={{ overflow: 'auto !important', height: '100vh !important' }}>

                {(render === DocumentLabels.BANK_STATEMENTS) && (
                  <>
                    <div className='cardNew no-border-card' style={{ border: 'none !important' }}>
                      <div className='section-heading'>
                        <h2>
                          Bank Statements {uploadedCorrectStatements && <CheckCircleIcon color='var(--sucess)' />}
                          {validateStmtsNow &&
                            loanApplication.bankStatementsReportFilePath &&
                            fileGroup.length &&
                            fileGroup.some(({ type }: any) => type === 'bank-statement') &&
                            !removeAllUploadedStatements &&
                            !uploadedCorrectStatements && <CheckCircleIcon color='var(--warning)' />}
                        </h2>
                        <hr className='text-gray-400' />
                      </div>
                      <div>
                        {validateStmtsNow && (
                          <div className='card-body'>
                            <BankStatementValidator
                              refId={loanApplication?.id}
                              refType={loanApplication?.applicationType}
                              setUploadedCorrectStatements={setUploadedCorrectStatements}
                              uploadedCorrectStatements={uploadedCorrectStatements}
                              setUploadedFiles={setUploadedFiles}
                              setIsBankReportGenerated={setIsBankReportGenerated}
                              isBankReportGenerated={isBankReportGenerated}
                              removeAllUploadedStatements={setRemoveAllUploadedStatements}
                              validateMonthsTill={6}
                              showNewInstructions={true}
                              setIsBankStatementUploading={setIsUploading}
                            />
                          </div>
                        )}
                        {!validateStmtsNow && (
                          <>
                            <div className='bank-statement-upload mb-3 rounded' style={{ width: '100%' }}>
                              <FileUploadInfo />
                            </div>
                            <div
                              className='uploadBox'
                              style={{
                                border: '1px dashed var(--primary-color)',
                                padding: '63px 40px',
                                background: 'var(--primary-light-color)',
                                minHeight: '150px',
                                fontSize: '14px',
                                marginBottom: '15px',
                                borderRadius: '10px',
                                alignItems: 'center',
                              }}
                            >
                              <Stack
                                style={{
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                                gap={2}
                              >
                                <div className='upload mb-4'>
                                  <input
                                    id='upload-file-bank'
                                    type='file'
                                    multiple
                                    accept='application/pdf'
                                    onChange={(e: any) => handleFileUpload(e, 'bank-statement')}
                                    onDrop={(e: React.DragEvent) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                      const files = e.dataTransfer.files
                                      if (files.length) {
                                        const event = { target: { files, validity: { valid: true } } }
                                        handleFileUpload(event, 'bank-statement', ['application/pdf'])
                                      }
                                    }}
                                    onDragOver={(e: React.DragEvent) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                    }}
                                    onDragLeave={(e: React.DragEvent) => {
                                      e.preventDefault()
                                      e.stopPropagation()
                                    }}
                                  ></input>
                                  <label
                                    htmlFor='upload-file-bank'
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      paddingTop: '10px',
                                    }}
                                  >
                                    <div
                                      className='file-uploader'
                                      style={{
                                        cursor: 'pointer',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <UploadIcon color='var(--primary-color)' />
                                      <span className='dragDropTitle'>Drag & Drop or Click to Upload Bank Statements</span>
                                    </div>
                                    <div className='file-uploader-sub'>Supported format: PDF</div>
                                  </label>
                                </div>
                              </Stack>
                            </div>
                            <div className='uploadedCapsulesWrap'>
                              <Stack
                                className='uploadedCapsules gridCapsules'
                                style={{
                                  display: 'grid',
                                  gridTemplateColumns: 'repeat(6, 1fr)',
                                  gap: '12px',
                                  fontSize: '12px',
                                  minWidth: '100%',
                                }}
                              >
                                {fileGroup && fileGroup.length > 0 && (
                                  <>
                                    {fileGroup
                                      .filter(({ type }: any) => type === 'bank-statement')
                                      .map(({ file, type, id }: any, i: number) => {
                                        const filename = file.filename.split('.')
                                        const name = filename[0].substring(0, 15)
                                        const extension = filename[1]

                                        return (
                                          <div
                                            key={i}
                                            style={{
                                              fontSize: 14,
                                              color: '#616B75',
                                              background: '#F9FAFA',
                                              padding: '8px 16px',
                                              display: 'flex',
                                              borderRadius: '20px',
                                              border: '1px solid #E0E0E0',
                                              justifyContent: 'space-between',
                                              alignItems: 'center',
                                              width: '100%',
                                            }}
                                            title={file.filename}
                                          >
                                            <span>{`${name}...${extension}`}</span>
                                            <Xicon
                                              onClick={() => removeSingleFile(id)}
                                              className='cursor-pointer'
                                            />
                                          </div>
                                        )
                                      })}
                                  </>
                                )}
                              </Stack>
                            </div>
                          </>
                        )}
                        {uploadedCorrectStatements ? (
                          <div className='text-success' style={{
                            fontSize: '21px',
                            fontWeight: 700
                          }}>
                            Your bank statements were successfully validated. You may upload more bank statements if needed.
                          </div>
                        ) : null}
                        {validateStmtsNow &&
                          loanApplication.bankStatementsReportFilePath &&
                          fileGroup.length &&
                          fileGroup.some(({ type }: any) => type === 'bank-statement') &&
                          !removeAllUploadedStatements &&
                          !uploadedCorrectStatements ? (
                          <div className='text-alert' style={{
                            fontSize: '21px',
                            fontWeight: 700
                          }}>
                            You have already uploaded your bank statements, now you can either re-upload your bank
                            statements or proceed further.
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {loanType && loanType.toLowerCase() === AlexiApplicationTypes.RECURRING_APPLICATION ? (
                      <div className='cardNew'>
                        <div className='section-heading'>
                          <h2>
                            Revenue Details{' '}
                            {fileGroup &&
                              fileGroup.filter(({ type }: any) => type === 'revenue-financing-statement').length >
                              0 && <CheckCircleIcon color='var(--sucess)' />}
                          </h2>
                          <hr className='text-gray-400' />
                        </div>
                        <div className='bank-statement-upload mb-3 rounded p-4 '>
                          <ul className='fs-4'>
                            <li>
                              <span>
                                You can download the sample template:{' '}
                                <a
                                  href={toAbsoluteUrl('/media/alexi/downloadtemplate.xlsx')}
                                  target='_blank'
                                  rel='noopener noreferrer'
                                >
                                  Download the template
                                </a>
                              </span>
                            </li>
                            <li>
                              <span>
                                The instructions are clearly mentioned in the document on how to complete/fill
                              </span>
                            </li>
                            <li>
                              <span>
                                Do not change any headers and request you to fill all information requested{' '}
                              </span>
                            </li>
                            <li>
                              <span>
                                {' '}
                                Once you fill in the application please upload the file using Browse Files button
                              </span>
                            </li>
                          </ul>
                        </div>

                        <div
                          className='uploadBox'
                          style={{
                            border: '1px dashed var(--primary-color)',
                            padding: '63px 40px',
                            background: 'var(--primary-light-color)',
                            minHeight: '150px',
                            fontSize: '14px',
                            marginBottom: '15px',
                            borderRadius: '10px',
                            alignItems: 'center',
                          }}
                        >
                          <Stack
                            style={{
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            gap={2} // Increased gap for better spacing
                          >
                            <div className='upload mb-4'>
                              <input
                                id='upload-file-revenue'
                                type='file'
                                multiple
                                accept='.xlsx'
                                onChange={(e: any) =>
                                  handleFileUpload(e, 'revenue-financing-statement', [
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                  ])
                                }
                                onDrop={(e: React.DragEvent) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                  const files = e.dataTransfer.files
                                  if (files.length) {
                                    const event = { target: { files, validity: { valid: true } } }
                                    handleFileUpload(event, 'revenue-financing-statement', [
                                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                    ])
                                  }
                                }}
                                onDragOver={(e: React.DragEvent) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                }}
                                onDragLeave={(e: React.DragEvent) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                }}
                              ></input>
                              <label
                                htmlFor='upload-file-revenue'
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  paddingTop: '10px',
                                }}
                              >
                                <div
                                  className='file-uploader'
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                  }}
                                >
                                  <UploadIcon color='var(--primary-color)' />

                                  <span className='dragDropTitle'>Drag & Drop or Click to Upload Revenue Statements</span>
                                </div>
                                <div className='file-uploader-sub'>Supported formats: XLSX, XLS</div>
                              </label>
                            </div>
                          </Stack>
                        </div>
                        <div className='uploadedCapsulesWrap'>
                          <Stack
                            className='uploadedCapsules gridCapsules'
                            style={{
                              display: 'grid', // Change to grid layout
                              gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                              gap: '12px', // Adjusted gap for better spacing
                              fontSize: '12px',
                              minWidth: '100%',
                            }}
                          >
                            {fileGroup && fileGroup.length > 0 && (
                              <>
                                {fileGroup
                                  .filter(({ type }: any) => type === 'revenue-financing-statement')
                                  .map(({ file, type, id }: any, i: number) => {
                                    const filename = file.filename.split('.')
                                    const name = filename[0].substring(0, 15)
                                    const extension = filename[1]

                                    return (
                                      <div
                                        key={i}
                                        style={{
                                          fontSize: 14,
                                          color: '#616B75',
                                          background: '#F9FAFA',
                                          borderRadius: '20px',
                                          border: '1px solid #E0E0E0',
                                          padding: '8px 16px',
                                          display: 'flex', // Use flex to position items
                                          justifyContent: 'space-between', // Space between text and icon
                                          alignItems: 'center', // Center items vertically
                                          width: '100%', // Set to 100% to fill the grid cell
                                        }}
                                        title={file.filename}
                                      >
                                        <span>{`${name}...${extension}`}</span>
                                        <Xicon onClick={() => removeSingleFile(id)} className='cursor-pointer' />
                                      </div>
                                    )
                                  })}
                              </>
                            )}
                          </Stack>
                        </div>
                      </div>
                    ) : null}
                  </>)
                }

                {(render === DocumentLabels.FINANCIAL_STATEMENTS) && (
                  <>
                    {/* {loanApplication.amountRequested > 250000 && ( */}
                    <div className='cardNew no-border-card'>
                      <FinancialStatementsUploadForAgentClientOnboarding
                        fileGroup={fileGroup}
                        handleFileUpload={handleFileUpload}
                        applicationid={loanApplication.id}
                        removeSingleFile={removeSingleFile}
                        queueFsFile={queueFsFile}
                        showNewInstructions={true}
                        setIsFinancialStatementUploading={setIsUploading}
                        uploadingType={uploadingType}
                        uploadingFinancialStatement={uploadingFinancialStatements}
                        setUploadingFinancialStatement={setUploadingFinancialStatements}
                      />
                    </div>
                    {/* )} */}
                  </>
                )}

                {(render === DocumentLabels.FORM_C_S) && (
                  <>
                    <DocumentUploadSection
                      id='cs-iras-form'
                      title={DocumentLabels.FORM_C_S}
                      description="Drag & Drop or Click to Upload Latest 2 Years' Form C/Form C-S IRAS (Optional)"
                      supportedFormatInCommanText='Supported formats: PDF, DOCX'
                      learnMoreLink={{href: 'https://credilinq-web.s3.ap-southeast-1.amazonaws.com/Company_IRAS_Form.pdf', text: 'Learn What Is Form C/Form C-S'}}
                      fileTypes={[
                        'application/pdf',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                      ]}
                      handleFileUpload={handleFileUpload}
                      fileGroup={fileGroup}
                      FileItem={FileItem}
                      removeSingleFile={removeSingleFile}
                      removeAllFiles={removeAllFiles}
                      loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                    />
                  </>
                )}

                {render === DocumentLabels.COMPANY_LOAN_DECLARATION && (

                  <DocumentUploadSection
                      id='company-loan-declaration'
                      title={DocumentLabels.COMPANY_LOAN_DECLARATION}
                      description="Drag & Drop or Click to Upload Company Loan Declaration"
                      supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                      fileTypes={[
                        'application/pdf',
                        'application/vnd.ms-excel',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      ]}
                      handleFileUpload={handleFileUpload}
                      fileGroup={fileGroup}
                      FileItem={FileItem}
                      removeSingleFile={removeSingleFile}
                      downloadLink='https://credilinq-web.s3.ap-southeast-1.amazonaws.com/Loan_Declaration_CCRP.xlsx'
                      removeAllFiles={removeAllFiles}
                      loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                    />
                )}

                {(render === DocumentLabels.LATEST_4_QUARTERS_GST_RETURNS) && (
                  <DocumentUploadSection
                      id={DocumentType.LATEST_4_QUARTERS_GST_RETURNS}
                      title={DocumentLabels.LATEST_4_QUARTERS_GST_RETURNS}
                      description="Drag & Drop or Click to Upload Latest 4 Quarters' GST Returns (F5)"
                      supportedFormatInCommanText='Supported formats: PDF'
                      fileTypes={[
                        'application/pdf',
                      ]}
                      handleFileUpload={handleFileUpload}
                      fileGroup={fileGroup}
                      FileItem={FileItem}
                      removeSingleFile={removeSingleFile}
                      removeAllFiles={removeAllFiles}
                      loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                    />
                  )
                }

                {(render === DocumentLabels.LATEST_MONTHS_ACRA) && (
                  <DocumentUploadSection
                      id={DocumentType.LATEST_MONTHS_ACRA}
                      title="Latest Month’s ACRA of the Company"
                      description="Drag & Drop or Click to Upload Latest Month’s ACRA of the Company"
                      supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                      fileTypes={[
                        'application/pdf',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'application/vnd.ms-excel',
                      ]}
                      handleFileUpload={handleFileUpload}
                      fileGroup={fileGroup}
                      FileItem={FileItem}
                      removeSingleFile={removeSingleFile}
                      removeAllFiles={removeAllFiles}
                      loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                    />
                )}

              {(render === DocumentLabels.LATEST_AR_AP_AGEING) && (
                <DocumentUploadSection
                  id={DocumentType.LATEST_AR_AP_AGEING}
                  title={DocumentLabels.LATEST_AR_AP_AGEING}
                  description="Drag & Drop or Click to Upload Latest AR & AP Ageing (Optional)"
                  supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                  fileTypes={[
                    'application/pdf',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                  ]}
                  handleFileUpload={handleFileUpload}
                  fileGroup={fileGroup}
                  FileItem={FileItem}
                  removeSingleFile={removeSingleFile}
                  removeAllFiles={removeAllFiles}
                  loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                />
              )}

              {(render === DocumentLabels.NRIC_OF_GUARANTORS) && (
                <DocumentUploadSection
                  id={DocumentType.NRIC_OF_GUARANTORS}
                  title={DocumentLabels.NRIC_OF_GUARANTORS}
                  description="Drag & Drop or Click to Upload NRIC of Guarantors"
                  supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                  fileTypes={[
                    'application/pdf',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                  ]}
                  handleFileUpload={handleFileUpload}
                  fileGroup={fileGroup}
                  FileItem={FileItem}
                  removeSingleFile={removeSingleFile}
                  removeAllFiles={removeAllFiles}
                  loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                />
              )
              }

                {(render === DocumentLabels.LATEST_MONTHS_CBS_REPORT) && (
                  <DocumentUploadSection
                    id={DocumentType.LATEST_MONTHS_CBS_REPORT}
                    title={DocumentLabels.LATEST_MONTHS_CBS_REPORT}
                    description="Drag & Drop or Click to Upload Latest Month’s CBS Report of Guarantors"
                    supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                    fileTypes={[
                      'application/pdf',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/vnd.ms-excel',
                    ]}
                    handleFileUpload={handleFileUpload}
                    fileGroup={fileGroup}
                    FileItem={FileItem}
                    removeSingleFile={removeSingleFile}
                    removeAllFiles={removeAllFiles}
                    loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                  />
                )}

                {(render === DocumentLabels.LATEST_MONTHS_MLCB_REPORT) && (
                  <DocumentUploadSection
                    id={DocumentType.LATEST_MONTHS_MLCB_REPORT}
                    title={DocumentLabels.LATEST_MONTHS_MLCB_REPORT}
                    description="Drag & Drop or Click to Upload Latest Month’s MLCB Report of Guarantors"
                    supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                    fileTypes={[
                      'application/pdf',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/vnd.ms-excel',
                    ]}
                    handleFileUpload={handleFileUpload}
                    fileGroup={fileGroup}
                    FileItem={FileItem}
                    removeSingleFile={removeSingleFile}
                    removeAllFiles={removeAllFiles}
                    loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                  />
                )}

                {(render === DocumentLabels.LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH) && (
                  <DocumentUploadSection
                    id={DocumentType.LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH}
                    title={DocumentLabels.LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH}
                    description="Drag & Drop or Click to Upload Latest Month’s Basic Individual Search of Guarantors"
                    supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                    fileTypes={[
                      'application/pdf',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/vnd.ms-excel',
                    ]}
                    handleFileUpload={handleFileUpload}
                    fileGroup={fileGroup}
                    FileItem={FileItem}
                    removeSingleFile={removeSingleFile}
                    removeAllFiles={removeAllFiles}
                    loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                  />
                )}

                {(render === DocumentLabels.LATEST_YEARS_CPF_STATEMENTS) && (
                  <DocumentUploadSection
                    id={DocumentType.LATEST_YEARS_CPF_STATEMENTS}
                    title={DocumentLabels.LATEST_YEARS_CPF_STATEMENTS}
                    description="Drag & Drop or Click to Upload Latest Year’s CPF Statements of Guarantors (Optional)"
                    supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                    fileTypes={[
                      'application/pdf',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/vnd.ms-excel',
                    ]}
                    handleFileUpload={handleFileUpload}
                    fileGroup={fileGroup}
                    FileItem={FileItem}
                    removeSingleFile={removeSingleFile}
                    removeAllFiles={removeAllFiles}
                    loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                  />
                )}

                {(render === DocumentLabels.LATEST_2_YEARS_NOA) && (
                  <DocumentUploadSection
                    id={DocumentType.LATEST_2_YEARS_NOA}
                    title={DocumentLabels.LATEST_2_YEARS_NOA}
                    description="Drag & Drop or Click to Upload Latest 2 Years’ NOA of Guarantors"
                    supportedFormatInCommanText='Supported formats: PDF, XLXS, XLS'
                    fileTypes={[
                      'application/pdf',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/vnd.ms-excel',
                    ]}
                    handleFileUpload={handleFileUpload}
                    fileGroup={fileGroup}
                    FileItem={FileItem}
                    removeSingleFile={removeSingleFile}
                    removeAllFiles={removeAllFiles}
                    loading={{ type: uploadingType, isLoading: onSuccessCreateIncomeDocument.loading }}
                  />
                )}

                {openVerification && (
              <CompanyVerification
                show={openVerification}
                handleClose={() => setOpenVerification(false)}
              // goToStep={goToStep}
              />
            )}

                {showAlert && (
                  <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
                    {alertMsg}
                  </Alert>
                )}
                <CustomLoaderModal
                  openCustomLoaderModal={openCustomLoaderModal}
                  setOpenCustomLoaderModal={setOpenCustomLoaderModal}
                  message='Please wait while we process your documents. This may take a few moments. Do not refresh or close your browser window.'
                />
                <Modal
                  className='bg-transparent'
                  id='kt_mega_menu_modal'
                  data-backdrop='static'
                  aria-hidden='true'
                  role='dialog'
                  tabIndex='-1'
                  contentClassName='shadow-none'
                  show={reuploadWarningModal}
                >
                  <div className='modal-content'>
                    <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
                      <div>
                        <h3 className='fw-bold m-0'>
                          Bank Statements Validation Mode
                          <div
                            className='btn btn-icon btn-sm btn-light-primary ms-2'
                            data-bs-dismiss='modal'
                            style={{ float: 'right' }}
                            onClick={() => setReuploadWarningModal(false)}
                          >
                            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                          </div>
                        </h3>
                        <div className='mt-2'>
                          Are you sure you want to{' '}
                          <b>
                            {!validateStmtsNow
                              ? 'Validate Bank-Statements'
                              : 'Skip Bank-Statements Validation'}
                          </b>
                          ? This will remove all of your previously uploaded statements.
                        </div>
                      </div>
                    </div>
                    <div className='d-flex flex-center mt-5 mb-5'>
                      <button className='btn btn-lg btn-primary me-3' onClick={reuploadAccepted}>
                        I understand
                      </button>
                    </div>
                  </div>
                </Modal>
              </div>
            </Box>
          </Box>
          <Box
            className=''
            sx={{
              padding: '16px 16px 0px 16px',
              background: 'var(--card-bg)',
              borderRadius: '4px',
              display: 'inline-block',
              width: '100%',
              marginTop: { md: 2, lg: 0 },
              '@media (min-width: 1444px)': {
                marginTop: 2,
              },
            }}>
            <div className='d-flex justify-content-between'>
            <button
              className='button button-outline-primary'
              onClick={backLink}
              disabled={(onSuccessCreateIncomeDocument.loading || isUploading)}
            >
                <LeftArowIcon color='currentColor' />
                Back
              </button>
              {(() => {
                // Use the dedicated FS validation function
                const hasValidFinancialPrefixes = areAllFsYearsComplete(fileGroup)

              const shouldDisable = ((
                validateStmtsNow
                  ? (!isBankReportGenerated && !uploadedCorrectStatements) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.FINANCIAL_STATEMENTS) ||
                  !hasValidFinancialPrefixes ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.COMPANY_LOAN_DECLARATION)
                  : !fileGroup.some(({ type }: any) => type === DocumentType.BANK_STATEMENTS) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.FINANCIAL_STATEMENTS) ||
                  !hasValidFinancialPrefixes ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.COMPANY_LOAN_DECLARATION)
              )
                || (
                  !fileGroup.some(({ type }: any) => type === DocumentType.LATEST_MONTHS_ACRA) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.LATEST_4_QUARTERS_GST_RETURNS) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.NRIC_OF_GUARANTORS) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.LATEST_MONTHS_CBS_REPORT) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.LATEST_MONTHS_MLCB_REPORT) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.LATEST_MONTHS_BASIC_INDIVIDUAL_SEARCH) ||
                  !fileGroup.some(({ type }: any) => type === DocumentType.LATEST_2_YEARS_NOA)
                ))  
                const btnBg = shouldDisable ? 'grey' : 'var(--secondary-color)'
                return (
                  <button
                    className='button button-primary'
                    style={{
                      background: btnBg,
                    }}
                    disabled={shouldDisable}
                    onClick={() => submitAll()}
                  >
                    Save and Continue
                    <RightAeroIcon color='currentColor' />
                  </button>
                )
              })()}
            </div>
          </Box>
        </>
      }

      {allDocumentSubmitted && (
        <DocumentSubmittedScreen />
      )}
    </Box>
  )
}

export { Step2 }
